import { Controller } from "@hotwired/stimulus"

/**
 * Filters a list of items by the text typed into the input — e.g. the
 * "All Views" menu in the beta tasks tab row.
 */
export default class extends Controller {
  static targets = ["input", "item"]

  filter() {
    const query = this.inputTarget.value.toLowerCase()

    this.itemTargets.forEach(item => {
      item.classList.toggle('d-none', !item.textContent.toLowerCase().includes(query))
    })
  }

  focus() {
    this.inputTarget.focus()
  }
}
